import { DragDropModule } from '@nomad2102npm/cdk/drag-drop'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatSelectModule } from '@angular/material/select'
import { MatSliderModule } from '@angular/material/slider'
import { AccessSelectorComponent } from '@app/shared/access-selector/access-selector.component'
import { DateTimeComponent } from '@app/shared/cell-types/date-time/date-time.component'
import { DateComponent } from '@app/shared/cell-types/date/date.component'
import { AutoFocusDirective } from '@app/shared/cell-types/focus.directive'
import { LinkSettingsComponent } from '@app/shared/cell-types/link/link-settings/link-settings.component'
import { LinkComponent } from '@app/shared/cell-types/link/link.component'
import { RangeComponent } from '@app/shared/cell-types/range/range.component'
import { ColorPickerComponent } from '@app/shared/color-picker/color-picker.component'
import { EnvDirective } from '@app/shared/env.directive'
import { FieldTypeSelectorComponent } from '@app/shared/field-type-selector/field-type-selector.component'
import { FieldsCollectionComponent } from '@app/shared/fields-collection/fields-collection.component'
import { GroupingValuesComponent } from '@app/shared/grouping-values/grouping-values.component'
import { IconPickerComponent } from '@app/shared/icon-picker/icon-picker.component'
import { ShowIfOperationCodeMatchExpectedOperationDirective } from '@app/shared/show-if-operation-code-match-expected-operation.directive'
import { TypedTemplateDirective } from '@app/shared/typed-template.directive'
import { ModalManagerModule } from '@components-library/tb-modal-manager/modal-manager.module'
import { TbTagComponent } from '@components-library/tb-tags'
import { PipesModule } from '@core/pipes/pipes.module'
import { TranslocoModule } from '@jsverse/transloco'
import { NgxColorsModule } from 'ngx-colors'
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material'
import { FieldNameComponent } from './field-name/field-name.component'
import { UserAvatarComponent } from './user-avatar/user-avatar.component'
import { RecordFieldsComponent } from 'src/app/shared/record-fields/record-fields.component'

const forExport = [
    FieldNameComponent,
    UserAvatarComponent,
    EnvDirective,
    ShowIfOperationCodeMatchExpectedOperationDirective,
    AccessSelectorComponent,
    FieldsCollectionComponent,
    GroupingValuesComponent,
    TypedTemplateDirective,
    FieldTypeSelectorComponent,
    ColorPickerComponent,
    IconPickerComponent,
    AutoFocusDirective,
    RecordFieldsComponent,
]

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        TranslocoModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        TbTagComponent,
        MatExpansionModule,
        DragDropModule,
        MatInputModule,
        MatMenuModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatCheckboxModule,
        MatSliderModule,
        MatSelectModule,
        MatBadgeModule,
        NgxDaterangepickerMd.forRoot(),
        NgxColorsModule,
        ReactiveFormsModule,
        TranslocoModule,
        PipesModule,
        ModalManagerModule,
        ...forExport,
        DateComponent,
        DateTimeComponent,
        RangeComponent,
        LinkComponent,
        LinkSettingsComponent,
    ],
    exports: forExport,
})
export class SharedModule {}
